
import OptOutComponent from './opt-out.component';
import * as optOutActions from './opt-out.actions';
import { optOutReducer } from './opt-out.reducer';
import ConfirmedComponent from './confirmed-component';

export {
  OptOutComponent,
  optOutActions,
  optOutReducer,
  ConfirmedComponent
}



// WEBPACK FOOTER //
// src/acct/opt-out/index.js